<template>
<div>
  <div>
    Background Color：
    <ColorButton @click="$refs.colorPickerVisible.toggle($event)" :color="backgroundColor" style="flex: 3"  />
    <OverlayPanel ref="colorPickerVisible">
      <ColorPicker
          :modelValue="backgroundColor"
          @update:modelValue="value => updateColor(value)"
      />
    </OverlayPanel>
  </div>
  <div style="padding-top: 20px">
    Background Image：
    <img
        @dblclick="openDialog = !openDialog"
        :src="imageSrc"
        :draggable="false"
        :style="{
              width: '200px',
            }"
        alt=""
    />
    <IconClose v-if="imageSrc != placeholder" @click="removeBackground" class="close"/>

    <Dialog v-model:visible="openDialog" modal header="Choose File" :style="{ width: '50rem' }">
      <FileManager @fileChosen="fileChosen" />

      <template #footer>
        <Button type="button" class="btn-secondary" label="Cancel" severity="secondary" @click="openDialog = false" />
      </template>
    </Dialog>
  </div>

</div>
</template>

<script setup lang="ts">
import {storeToRefs} from 'pinia'
import {useSlidesStore} from "@/store";
import useMicroservice from "@/hooks/useMicroservice";
import {onBeforeMount, ref} from "vue";
import ColorPicker from "@/components/ColorPicker/index.vue";
import ColorButton from "@/views/Editor/Toolbar/common/ColorButton.vue";
import FileManager from "@/views/components/element/FileManagerElement/index.vue";
import {SlideBackground} from "@/types/slides";

const slidesStore = useSlidesStore()
const { currentSlide } = storeToRefs(slidesStore)

const api = useMicroservice()

const colorPickerVisible = ref()
const imageSrc = ref('')
const openDialog = ref(false)

const backgroundColor = ref()
const placeholder = 'https://img.freepik.com/premium-vector/default-image-icon-vector-missing-picture-page-website-design-mobile-app-no-photo-available_87543-11093.jpg'

onBeforeMount(() => {
  backgroundColor.value = currentSlide.value.background?.color || '#fff'
  imageSrc.value = currentSlide.value.background?.image || placeholder
})

const updateColor = (color: string) => {
  backgroundColor.value = color
  const background: SlideBackground = {
    ...currentSlide.value.background,
    color: color,
  }
  slidesStore.updateSlide({ background })
  api.savePresentation()
}

const removeBackground = () => {
  imageSrc.value = placeholder
  const background: SlideBackground = {
    type: 'solid',
    color: currentSlide.value.background?.color || '#fff',
  }
  slidesStore.updateSlide({ background })
  api.savePresentation()
}

const fileChosen = (file) => {
  imageSrc.value = file.resultsThumbnailImg
  openDialog.value = false
  const background: SlideBackground = {
    ...currentSlide.value.background,
    type: 'image',
    image: file.resultsThumbnailImg,
    imageSize: 'cover',
  }
  slidesStore.updateSlide({ background })
  api.savePresentation()
}
</script>

<style scoped>

</style>
